import axios from 'axios';

// All backend API routes are under the /api prefix.
// REACT_APP_BACKEND_URL points to the backend root, so append /api here.
const API_BASE =
  (process.env.REACT_APP_VITE_API_URL || `${process.env.REACT_APP_BACKEND_URL || ''}/api` || 'http://localhost:8002/api');

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const aiAPI = {
  async createProject(name, description, userId) {
    const { data } = await axios.post(
      `${API_BASE}/ai-projects/`,
      {
        name,
        description,
        user_id: userId,
      },
      { headers: authHeaders() },
    );
    return data.project;
  },

  async getProject(projectId) {
    const { data } = await axios.get(`${API_BASE}/ai-projects/${projectId}`, {
      headers: authHeaders(),
    });
    return data.project;
  },

  async deleteProject(projectId) {
    const { data } = await axios.delete(`${API_BASE}/ai-projects/${projectId}`, {
      headers: authHeaders(),
    });
    return data;
  },

  async sendMessage(projectId, message) {
    const { data } = await axios.post(
      `${API_BASE}/ai-projects/${projectId}/chat`,
      { message },
      { headers: authHeaders() },
    );
    return data;
  },
};
